import _defineProperty from "/app/web/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "/app/web/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["companyId", "isMultiple", "isReadonly", "allowClear", "placeholder"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { Select, Space, Typography } from 'antd';
import { getCompanyStore } from 'core/modules/companies/company.store';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { sanitizeAll } from '../../utils/sanitize';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

/** Renders a select to select company bases. */
export var CompanyBaseSelect = function CompanyBaseSelect(_ref) {
  var _company$bases;

  var companyId = _ref.companyId,
      isMultiple = _ref.isMultiple,
      isReadonly = _ref.isReadonly,
      allowClear = _ref.allowClear,
      placeholder = _ref.placeholder,
      props = _objectWithoutProperties(_ref, _excluded);

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _getCompanyStore = getCompanyStore(),
      getCompanyById = _getCompanyStore.getCompanyById;

  var company = useMemo(function () {
    return getCompanyById(companyId);
  }, [getCompanyById, companyId]);
  var bases = (_company$bases = company === null || company === void 0 ? void 0 : company.bases) !== null && _company$bases !== void 0 ? _company$bases : [];
  return /*#__PURE__*/_jsx(Select, _objectSpread(_objectSpread({}, props), {}, {
    mode: isMultiple ? 'multiple' : undefined,
    allowClear: allowClear,
    bordered: !isReadonly,
    disabled: isReadonly,
    showSearch: true,
    filterOption: function filterOption(input, option) {
      return option.title.includes(sanitizeAll(input));
    },
    placeholder: isReadonly ? t('form.task.base.empty') : placeholder !== null && placeholder !== void 0 ? placeholder : t('form.task.base.placeholder'),
    children: bases.map(function (base) {
      return /*#__PURE__*/_jsx(Select.Option, {
        value: base.id,
        title: sanitizeAll("".concat(base.name, " ").concat(base.address)),
        children: /*#__PURE__*/_jsxs(OptionContent, {
          children: [/*#__PURE__*/_jsx(Typography.Text, {
            strong: true,
            children: base.name
          }), /*#__PURE__*/_jsx(Typography.Text, {
            type: "secondary",
            ellipsis: true,
            children: base.address
          })]
        })
      }, base.id);
    })
  }));
}; // Styles

var OptionContent = styled(Space).withConfig({
  displayName: "CompanyBaseSelect__OptionContent",
  componentId: "sc-1wulpek-0"
})([".ant-space{padding:10px 0;}.ant-space-item{.ant-typography{margin:0;}}"]);